import React, { useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  DialogContent,
} from '@mui/material';
import { useTypedSelector } from 'hooks/use-typed-selector';
import HTTP from '../../services/http';

const send_sms = async (message: string, number: string | null) => {
  const url = `${window.location.protocol}//${window.location.hostname}`;
  const smsPayload = {
    Body: message,
    From: `+1${number?.replace(/[^0-9.]/g, '')}`,
    Target: url,
  };
  await HTTP.post('/sms/inbound_test_tool', smsPayload);
};

const SendSMSInput: React.FC<any> = props => {
  const { close } = props;
  const mobile_phone_number = useTypedSelector(state => {
    const enabled_phone_entry = state.patient.filteredPhones?.find(
      item => item.sms === 'Opt in' && item.use === 'Mobile',
    );
    return enabled_phone_entry ? enabled_phone_entry.value : null;
  });
  const [input_text, setInput_text] = useState('');
  return (
    <Dialog open>
      <DialogTitle>{`Send an SMS from patient using number ${mobile_phone_number}`}</DialogTitle>
      <div className="contextmenu">
        <DialogContent>
          <TextField
            fullWidth
            label="Message"
            value={input_text}
            autoFocus
            onChange={e => setInput_text(e.target.value)}
          />
        </DialogContent>
      </div>
      <DialogActions>
        <Button onClick={close}>Close</Button>
        <Button
          disabled={(input_text || '')?.length === 0}
          onClick={() => {
            send_sms(input_text, mobile_phone_number);
            close();
          }}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendSMSInput;
